import { Injectable } from "@angular/core";
import { defer, Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { IIconData } from "./icon-picker.interface";

@Injectable({
    providedIn: "root",
})
export class IconPickerDataService {
    private loadIconData$?: Observable<IIconData>;

    public getIconData(): Observable<IIconData> {
        if (!this.loadIconData$) {
            this.loadIconData$ = defer(async () => {
                const data = await import("./icon-picker.data");
                return { icons: data.ICONS, categories: data.ICON_CATEGORIES } as IIconData;
            }).pipe(
                shareReplay(1),
            );
        }

        return this.loadIconData$;
    }
}
